import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = 'G-2S7XKXEGJM';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Sends a GA4 page_view on every React Router navigation. Initial gtag config
 * uses send_page_view: false so the first hit comes from here too (avoids a
 * double count on load).
 */
export function GaPageViews() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    // Browser path (includes basename /account), not the router-relative path.
    window.gtag('event', 'page_view', {
      page_path: `${window.location.pathname}${window.location.search}${window.location.hash}`,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
